import React, { Fragment, useState, useEffect } from 'react'
import { GoogleMap, withScriptjs, withGoogleMap, Marker, InfoWindow } from 'react-google-maps'
import { Link } from 'react-router-dom';
import * as AiIcons from 'react-icons/ai';
import * as VscIcons from 'react-icons/vsc';
import './mapstyles.css'
import { useForm } from 'react-hook-form';
import * as FcIcons from 'react-icons/fc';
import { Modal, Button } from "react-bootstrap";
import AxiosService from "../services/axios.service";
import AuthService from "../services/auth.service";
import $ from "jquery"
const API_PATH = "attorneys";
const GOOGLE_MAP_API_KEY = "AIzaSyBLoal-kZlb6tO5aDvkJTFC0a4WMp7oHUM";

function Map(match) {
  const { path } = match;

  const [mod, setMod] = useState(false);
  const [admin, setAdmin] = useState(false);
  const [attorneys, setAttorneys] = useState(null);
  const [attorney, setAttorney] = useState(null);
  const [results, setResults] = useState(0);
  const [deleteId, setDeleteId] = useState(0);
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
    console.log("close");
  };

  const confirmDelete = (id) => {
    setShow(true);
    setDeleteId(id);
  };

  function deleteAtt() {
    console.log("deleting case id: " + deleteId);
    setAttorneys(attorneys.map(x => {
      if (x.id === deleteId) { x.isDeleting = true; }
      return x;
    }));
    AxiosService.delete(API_PATH, deleteId).then(() => {
      setAttorneys(attorneys => attorneys.filter(x => x.id !== deleteId));
    });
    setShow(false);
  };




  useEffect(() => {
    const user = AuthService.getCurrentUser();
    if (user) {
      setMod(user.roles.includes("ROLE_MODERATOR"));
      setAdmin(user.roles.includes("ROLE_ADMIN"));
    }
    AxiosService.getAll(API_PATH).then(x => setAttorneys(x.data) & setResults(x.length));
  }, []);

  const { register, watch, formState: { errors }, handleSubmit } = useForm();

  function search() {
    var keyword = watch("query").toLowerCase();
    console.log("keyword: " + keyword);
    AxiosService.getAll(API_PATH).then(x => {
      console.log(JSON.stringify(x.data));
      //<td> {attorney.street_address} {attorney.city} {attorney.state} {attorney.zip}</td>
      //<td> {attorney.appellate_district}</td>
      var queries = x.data.filter(item =>  (item.name || "").toLowerCase().includes(keyword) /*|| item.appellate_district.toLowerCase().includes(keyword)*/ ||  (item.street_address || "").toLowerCase().includes(keyword) ||  (item.state || "").toLowerCase().includes(keyword) ||  (item.city || "").toLowerCase().includes(keyword) || (item.zip || "").toString().toLowerCase().includes(keyword))
      setAttorneys(queries)
      setResults(queries.length)
    }
    );
  }

  const loadGoogleMapScript = (callback) => {
    if (
      typeof window.google === "object" &&
      typeof window.google.maps === "object"
    ) {

    } else {
      const googleMapScript = document.createElement("script");
      googleMapScript.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_API_KEY}&libraries=places`;
      window.document.body.appendChild(googleMapScript);
      googleMapScript.addEventListener("load", callback);
    }
  };

  return (

    <Fragment >
      <GoogleMap
        defaultZoom={6}
        defaultCenter={{ lat: 38.907192, lng: -77.036873 }}
      >
        {attorneys && attorneys.map(attorney =>
          <Marker
            key={attorney.id}
            id={attorney.id}
            position={{
              lat: attorney.latitude,
              lng: attorney.longitude
            }}
            onClick={() =>
              setAttorney(attorney)


            }
          />
        )}
        {attorney &&
          <InfoWindow position={{
            lat: attorney.latitude,
            lng: attorney.longitude
          }}

            onCloseClick={() => {
              setAttorney(null);
            }}


          >


            <div style={{ marginRight: '.5rem' }} className="pickle">
              <h4 style={{ fontWeight: 'bold' }} >{attorney.name} {' '} </h4>
              <p>{attorney.email}</p>
              <p>{attorney.phone}</p>
              <Link to={`/attorneys/view/${attorney.id}`} className="btn btn-sm btn-info"> <VscIcons.VscOpenPreview size={12} /> View {attorney.name} <br></br></Link>
              <p> </p>
            </div>
          </InfoWindow>
        }

      </GoogleMap>

      <div className='pickle' style={{ zIndex: -1 }}>

        <br>
        </br>
        <form onSubmit={handleSubmit(search)} onReset={useEffect}>
          <div className="form-row">
            <div className="form-group col-5">
              <input name="query" type="text" ref={register} {...register("query", {})} className={`form-control ${errors.query ? 'is-invalid' : ''}`} />
              <div className="invalid-feedback">{errors.query?.message}</div>
            </div>
            <div className="form-group col-5">
              <button class="btn btn-light" type="submit">Search <FcIcons.FcSearch size={24} /></button>
            </div>
          </div>
        </form>
        <text>Results: {results}</text>
        <table className="table-crunch table table-bordered table-responsive table-hover table-hover-cursor">
          <thead style={{ width: '50%', marginTop: 15 }}>
            <tr >

              <th style={{ width: '10%' }}>Attorney Name</th>
              <th style={{ width: '12%' }}>Email</th>
              <th style={{ width: '40%' }}>Phone Number</th>
              <th style={{ width: '40%' }}>Indiviual Address</th>
              <th style={{ width: '10%' }}>Appellate District</th>
              <th style={{ width: '10%' }}>Admitted</th>
              <th style={{ width: '10%' }}>Practice area</th>
              <th style={{ width: '10%' }}>Month/Year Joined</th>
              <th style={{ width: '10%' }}>View</th>
            </tr>
          </thead>
          <tbody class="searchable">
            {attorneys && attorneys.map(attorney =>
              <tr onClick={() =>
                setAttorney(attorney)

              } key={attorney.id}>
                <td>{attorney.name}</td>
                {/* <td>{case_.case_id}</td> */}
                <td>{attorney.email}</td>
                <td> {attorney.phone}</td>
                <td> {attorney.street_address} {attorney.city} {attorney.state} {attorney.zip}</td>
                <td> {attorney.appellate_district}</td>
                <td>
                  {attorney.admitted}
                </td>
                <td>{attorney.practice_area}</td>
                <td>{attorney.month_year_joined}</td>
                <td style={{ whiteSpace: 'nowrap' }}>


                  <Link to={`/attorneys/view/${attorney.id}`} className="btn btn-sm btn-info mr-2"> <VscIcons.VscOpenPreview size={22} /> </Link>
                  {(mod || admin) && (
                    <Link to={`/attorneys/edit/${attorney.id}`} className="btn btn-sm btn-primary mr-2"> <AiIcons.AiTwotoneEdit size={22} /> </Link>
                  )}
                  {admin && (
                    <button
                      className="btn btn-sm btn-danger mr-2"
                      onClick={() => confirmDelete(attorney.id)}
                    >
                      <AiIcons.AiFillDelete size={22} />
                    </button>
                  )}
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Delete?</Modal.Title>
          </Modal.Header>
          <Modal.Body>Would you like to delete this firm?</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => deleteAtt(attorneys.id)}>
              OK
            </Button>
            <Button variant="primary" onClick={handleClose}>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      </div >

    </Fragment >

  );
}



const WrappedMap = withScriptjs(withGoogleMap(Map));

export default function map() {

  return (
    <div style={{ width: '70vw', height: '60vh', position: 'absolute', left: 270, zIndex: 1001 }}>
      <h1 style={{ textAlign: 'center' }}>Attorneys</h1>
      <Link to={`/attorneys/add`} style={{ marginTop: 10 }} className="btn btn-sm btn-success mb-2">Add Attorney</Link>
      <WrappedMap googleMapURL={`https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${GOOGLE_MAP_API_KEY}`}
        loadingElement={<div style={{ height: "100%" }} />}
        containerElement={<div style={{ height: "100%" }} />}
        mapElement={<div style={{ height: "100%" }} />}
      />

    </div>
  )
}

export { Map };